import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'react-dropzone-uploader/dist/styles.css';
import DropzoneCustom from "./DropzoneCustom";

import { useToast } from 'helpers/hooks';
import { ReactComponent as UploadIcon } from 'assets/svg/2_upload_dropzone.svg';
import { ReactComponent as CancelIcon } from 'assets/svg/cancel.svg';
import { ReactComponent as InfoIcon } from 'assets/svg/2_info.svg';
import { ReactComponent as CheckIcon } from 'assets/svg/check.svg';
import { ReactComponent as EditIcon } from 'assets/svg/2_pen.svg';
import { ReactComponent as BinIcon } from 'assets/svg/2_bin.svg';
import styles from 'css_modules/Upload.module.css';
import {request} from 'helpers/tools';

let newuuids = [];

const Layout = ({ input, previews, dropzoneProps, files}) => {
  if (newuuids.length > 0) {
    sessionStorage.setItem("newUuids", newuuids.join());
  }

  const hasFiles = files.length > 0;

  return (
    <>
      <section className={`${styles.wrapper} ${hasFiles ? styles.withFiles : styles.fullPage}`}>
        <figure className={hasFiles ? styles.leftSide : styles.dropzoneBox}>
          <div {...dropzoneProps}>{input}</div>
        </figure>

        {hasFiles && (
          <div className={styles.rightSide}>
            <div className={styles.headingLight}>Nahrané soubory</div>
            <div className={styles.scrollablePreviews}>{previews}</div>
          </div>
        )}
      </section>
      <figcaption className={hasFiles ? styles.hintWithFiles : styles.hint}>
        <span className={styles.hintText}>
          <InfoIcon />
          Doklad je také možné nahrát prostřednictvím emailové adresy či mobilní aplikace.
        </span>
      </figcaption>
    </>
  );
};
/*
const cloneByTemplate = (newuuid) => {
  let json = JSON.parse(sessionStorage.getItem("template"));
  if (json) {
    try {
      let cloneParams = { target_uuid: newuuid, source_uuid: json["templateuuid"] };
      request('/load_from_template/', 'POST', cloneParams);
      sessionStorage.setItem("template", undefined);
    } catch {
      console.error("No template json stored.");
    }
  }
};*/

const Preview = ({ fileWithMeta }) => {
  const { meta, cancel, remove, xhr } = fileWithMeta;
  const { name, size, percent, status } = meta;

  const isUploading = status === 'uploading';
  const isDone = status === 'done';
  const isError = status === 'error_upload' || status === 'error_file_size';

  const formatBytes = b => {
    const units = ['bytes', 'kB', 'MB', 'GB'];
    let i = 0, n = b;
    while (n >= 1024 && i < units.length - 1) {
      n /= 1024;
      i++;
    }
    return `${n.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
  };

  let uuid;
  try {
    if (xhr?.response) uuid = JSON.parse(xhr.response).uuid;
  } catch { uuid = undefined; }

  const detailUrl = uuid ? `/my_documents/${uuid}/general` : null;
  if (status === 'aborted') return null;

 
  const displayPercent = Math.max(percent, 1);
 
  return (
    <div className={styles.previewContainer}>
      <div className={styles.progressContainer}>
        {/* FILE ROW */}
        <div className={styles.progressRow}>
          <span className={isDone ? styles.fileNameDone : styles.fileNameDefault}>
            {name}
          </span>

          <span className={styles.fileSize}>{formatBytes(size)}</span>

          {/* Progress dot pipe */}
          {isUploading && (
            <div className={styles.dotPipe}>
              <div
                className={styles.dot}
                style={{
                  left: `${displayPercent-7}%`,
                  transition: 'left 0.4s linear',
                  backgroundColor: isDone ? 'var(--purple)' : 'var(--purple)'
                }}
              />
            </div>
          )}

          {isUploading && <CancelIcon onClick={cancel} className={styles.cancelIcon} />}

          {isDone && detailUrl && (
            <div className={styles.iconContainer}>
                <CheckIcon className={styles.checkIcon} />
                <Link to={detailUrl}>
                  <EditIcon className={styles.editIcon} />
                </Link>
                <BinIcon
                  onClick={async () => {
                    try {
                      await request(`/my_documents/${uuid}/remove/`, 'POST');
                      remove(); 
                    } catch (e) {
                      console.error('Failed to remove file');
                    }
                  }}
                  className={styles.binIcon}
                />
            </div>
          )}

           {isError && <p className={styles.errorMessage}>Upload failed.</p>}
          {isError && <span className={styles.errorIcon}>!</span>}

         
        </div>

        
      </div>
    </div>
  );
};


const Content = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    height: '100%',
    width: '100%',
    gap: '1rem'
  }}>
    <UploadIcon className={styles.uploadIcon} />
    <span className={styles.dropzoneCaption}>
      Doklady nahrajete přetažením nebo kliknutím.<br /><br />
    </span>
    <div className={styles.uploadButton}>Nahrát doklad</div>
    <span className={styles.dropzoneCaption}>
      Podporované formáty dokumentu: <br />
      PDF, ISDOC, ISDOCX <br />
      JPG, PNG, TIF, BMP, GIF
    </span>
  </div>
);

export const Upload = ({isMobile, onMenuClick}) => {
  const [json, setJson] = useState(null);
  const showToast = useToast();

  useEffect(() => {
    const stored = sessionStorage.getItem("template");
    setJson(stored && stored !== 'undefined' ? JSON.parse(stored) : null);
  }, []);

  const templateName = json ? (json.templatename || json.templateuuid) : undefined;

  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('document_file', file);
    return {
      url: process.env.REACT_APP_API + '/upload/',
      headers: { 'Authorization': 'JWT ' + localStorage.getItem('DocspointJWT') },
      body
    };
  };

  const handleStatusChange = ({ meta }) => {
    if (meta.status === 'rejected_file_type') showToast('Nahrajte soubor ve formátu PDF');
  };

  return (
    <>
      <div className={styles.heading}>
        {isMobile && (
            <button 
                onClick={onMenuClick} 
                style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    marginRight: "1rem",
                    width: '28px',
                    height: '28px'
                }}
                aria-label="Open navigation menu"
            >
                <svg 
                    width="24" 
                    height="24" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="var(--primary, #007bff)" 
                    strokeWidth="2.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                >
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
            </button>
        )}

        {!templateName && 'Nahrát'}
        {templateName && `Nahrát (použitá šablona: ${templateName})`}
      </div>
      <div className={styles.dropzoneWrapper}>
        <DropzoneCustom
          LayoutComponent={Layout}
          PreviewComponent={Preview}
          inputContent={Content}
          inputWithFilesContent={Content}
          getUploadParams={getUploadParams}
          onChangeStatus={handleStatusChange}
          accept="application/pdf, application/xml, application/isdoc,application/octet-stream,"
          maxSizeBytes={31457280}
          classNames={{
            dropzone: styles.dropzone,
            inputLabel: styles.inputLabel,
            inputLabelWithFiles: styles.inputLabelWithFiles
          }}
          autoUpload={true}
        />
      </div>
    </>
  );
};
